import { supabaseClient } from "@/lib/supabase";
import { queryOptions, useQuery } from "@tanstack/react-query";

import { injection_locations_root_key } from "./selectInjectionLocations";

/** Builder (admin) list: every location, active or not. */
async function getInjectionLocationsForBuilder() {
    const { data } = await supabaseClient.from("injection_locations").select("*").throwOnError();
    return data ?? [];
}

export const injection_locations_builder_key = [...injection_locations_root_key, "builder"];

export const injectionLocationsBuilderQueryOptions = () => {
    return queryOptions({
        queryKey: injection_locations_builder_key,
        queryFn: async () => getInjectionLocationsForBuilder(),
    });
};

export function useInjectionLocationsBuilderQuery() {
    return useQuery(injectionLocationsBuilderQueryOptions());
}
